var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_899_4293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.08553 9.33789C3.11926 9.33789 2.33594 10.1212 2.33594 11.0875V19.2522C2.33594 20.2185 3.11926 21.0018 4.08553 21.0018C5.05179 21.0018 5.83512 20.2185 5.83512 19.2522V11.0875C5.83512 10.1212 5.05179 9.33789 4.08553 9.33789Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9137 9.33789C22.9474 9.33789 22.1641 10.1212 22.1641 11.0875V19.2522C22.1641 20.2185 22.9474 21.0018 23.9137 21.0018C24.8799 21.0018 25.6632 20.2185 25.6632 19.2522V11.0875C25.6632 10.1212 24.88 9.33789 23.9137 9.33789Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4155 9.33789H7.58517C7.26308 9.33789 7.00195 9.59902 7.00195 9.92111V19.2522C7.00168 20.6381 7.97686 21.8327 9.33476 22.1099V26.2506C9.33476 27.2168 10.1181 28.0002 11.0843 28.0002C12.0506 28.0002 12.8339 27.2168 12.8339 26.2506V22.1682H15.1667V26.2506C15.1667 27.2168 15.9501 28.0002 16.9163 28.0002C17.8826 28.0002 18.6659 27.2168 18.6659 26.2506V22.1099C20.0238 21.8327 20.999 20.6381 20.9987 19.2522V9.92111C20.9987 9.59902 20.7375 9.33789 20.4155 9.33789Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2403 2.42335L19.6621 1.00268C19.8937 0.778895 19.9001 0.409732 19.6764 0.17802C19.4526 -0.0536363 19.0834 -0.0600333 18.8517 0.163696C18.8469 0.168398 18.8421 0.173154 18.8374 0.17802L17.1812 1.83434C15.1526 0.953143 12.8493 0.953143 10.8208 1.83434L9.16453 0.176872C8.93287 -0.0469113 8.56365 -0.0404597 8.33987 0.191197C8.12161 0.417222 8.12161 0.775505 8.33987 1.00148L9.76054 2.42329C8.02861 3.56927 6.99132 5.51137 7.00204 7.58808C7.00204 7.91017 7.26316 8.1713 7.58525 8.1713H20.4156C20.7377 8.1713 20.9988 7.91017 20.9988 7.58808C21.0095 5.51143 19.9722 3.56933 18.2403 2.42335Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0832 5.8383C11.4053 5.8383 11.6664 5.57719 11.6664 5.25509C11.6664 4.93299 11.4053 4.67188 11.0832 4.67188C10.7611 4.67188 10.5 4.93299 10.5 5.25509C10.5 5.57719 10.7611 5.8383 11.0832 5.8383Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9152 5.8383C17.2373 5.8383 17.4985 5.57719 17.4985 5.25509C17.4985 4.93299 17.2373 4.67188 16.9152 4.67188C16.5931 4.67188 16.332 4.93299 16.332 5.25509C16.332 5.57719 16.5931 5.8383 16.9152 5.8383Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_899_4293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidIcon);
export default __webpack_public_path__ + "static/media/androidIcon.fdd2c2b46b64e5e43f1e2f717a3eedf0.svg";
export { ForwardRef as ReactComponent };